import React, { useState } from "react";
import { Bell } from "lucide-react";
import api, { formatApiError } from "@/api";
import { usePushSubscription } from "@/hooks/usePushSubscription";

export default function ChatPushSettings() {
  const { state, loading, error, subscribe, retry } = usePushSubscription();
  const [testing, setTesting] = useState(false);
  const [report, setReport] = useState(null);
  const [testError, setTestError] = useState("");
  const ios = /iphone|ipad|ipod/i.test(navigator.userAgent);

  const testPush = async () => {
    setTesting(true);
    setReport(null);
    setTestError("");
    try {
      const { data } = await api.post("/notifications/push/test");
      setReport(data);
    } catch (err) {
      setTestError(formatApiError(err));
    } finally {
      setTesting(false);
    }
  };

  return <section className="vb-chat__push" aria-label="Chat push alerts">
    <div className="vb-chat__push-heading"><Bell size={14} /><strong>Chat push alerts</strong></div>
    <p role="status">
      {state === "checking" && "Checking push on this device…"}
      {state === "subscribed" && "Push is enabled on this device."}
      {state === "unsubscribed" && "Push is off on this device. Enable it for background alerts."}
      {state === "denied" && "Notifications are blocked on this device. Allow them in your browser or phone settings."}
      {state === "unsupported" && (ios
        ? "Push is unavailable in this browser. In Safari, tap Share → Add to Home Screen, then open the installed app and enable push here."
        : "Push is unavailable in this browser or device.")}
      {state === "error" && `Could not check push on this device: ${error || "Please try again."}`}
    </p>
    <div className="vb-chat__push-actions">
      {state === "unsubscribed" && <button type="button" onClick={subscribe} disabled={loading}>{loading ? "Enabling…" : "Enable push"}</button>}
      {state === "error" && <button type="button" onClick={retry}>Try again</button>}
      {state === "subscribed" && <button type="button" onClick={testPush} disabled={testing}>{testing ? "Sending test…" : "Send test push"}</button>}
    </div>
    {report && <p className="vb-chat__push-result" role="status">
      Test push to your account: {report.accepted} accepted, {report.failed} failed, {report.expired} expired
      {" "}({report.devices} device{report.devices === 1 ? "" : "s"} checked).
      {" "}Accepted means the push service received it; display on your phone cannot be confirmed.
    </p>}
    {testError && <p className="vb-chat__push-error" role="alert">Test push failed: {testError}</p>}
  </section>;
}